import { render } from "./WCSideBarV2.vue?vue&type=template&id=284c2d54&scoped=true"
import script from "./WCSideBarV2.vue?vue&type=script&lang=js"
export * from "./WCSideBarV2.vue?vue&type=script&lang=js"

import "./WCSideBarV2.vue?vue&type=style&index=0&id=284c2d54&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284c2d54"]])

export default __exports__